// import { useState } from 'react';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { BaseUrl } from '../../../Actions/Base';

// const InstructorCards = ({ instructors, CoursePackage }) => {
//   const [inVehicleIndex, setInVehicleIndex] = useState(0);
//   const [inClassIndex, setInClassIndex] = useState(0);
//   const [onlineIndex, setOnlineIndex] = useState(0);

//   const {
//     DrivingHours,
//     InClassHours,
//     OnlineHours
//   } = CoursePackage;
  

//   const handleNext = (type) => {
//     if (type === 'vehicle') {
//       setInVehicleIndex((prev) => (prev + 1) % instructors.length);
//     } else if (type === 'class') {
//       setInClassIndex((prev) => (prev + 1) % instructors.length);
//     } else {
//       setOnlineIndex((prev) => (prev + 1) % instructors.length);
//     }
//   };

//   const handlePrev = (type) => {
//     if (type === 'vehicle') {
//       setInVehicleIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     } else if (type === 'class') {
//       setInClassIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     } else {
//       setOnlineIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     }
//   };


//   const renderInstructorCard = (instructor, label, hours, type, color, borderColor) => (
//     <div className="flex justify-between w-[450px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
//       <div className="flex gap-[10px] items-center">
//         <img
//           src={`${BaseUrl}/api/images/Instructors?url=${instructor?.Instructor?.ProfileImage}`}
//           alt="Instructor"
//           className="w-[66px] h-[66px] rounded-[9px]"
//         />
//         <p className="text-[16px] font-semibold text-[#696974] w-[130px]">
//           {instructor?.FirstName} {instructor?.LastName}
//         </p>
//         <div
//           onClick={() => handlePrev(type)}
//           className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
//         >
//           <ArrowBackIcon sx={{ color: 'white' }} />
//         </div>
//         <div
//           onClick={() => handleNext(type)}
//           className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
//         >
//           <ArrowForwardIcon sx={{ color: 'white' }} />
//         </div>
//       </div>

//       <div
//         className="bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
//         // style={{ border: '1px solid #0AA630' }}
//         style={{ backgroundColor: `${color}`, border: `1px solid ${borderColor}` }}
//       >
//         <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">
//           {label}
//         </p>
//         <p className="text-[16px] text-[#696974] font-semibold">{hours}</p>
//       </div>
//     </div>
//   );

//   return (
//     <div className="flex flex-wrap justify-center 4xl:justify-between items-center gap-[30px] w-full">
//       {renderInstructorCard(instructors[inVehicleIndex], 'In-Vehicle Classes', DrivingHours, 'vehicle', '#EBF8EE', '#0AA630')}
//       {renderInstructorCard(instructors[inClassIndex], 'In-Class Classes', InClassHours, 'class', '#FAFAFB', '#1F7BF4')}
//       {renderInstructorCard(instructors[onlineIndex], 'Online Classes', OnlineHours, 'online', '#FFEBEB', '#FC0000')}
//     </div>
//   );
// };

// export default InstructorCards;


import { useState, useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { BaseUrl } from '../../../Actions/Base';
import ScheduleConfirmationPopup from './ScheduleConfirmationPopup';

const InstructorCards = ({
  instructors,
  CoursePackage,
  setInstructorSelectedType,
  SelectInstructorCallback,
  instructorSelectedType,
  addClassEvents,
  setShowScheduleConfirmationPopup,
  showScheduleConfirmationPopup,
  setFinalClassesSchedule,
  setAddClassEvents,
  finalClassesSchedule,
  activeType,
  setActiveType,
  setFinalDrivingClassesSchedule,
  setFinalInClassClassesSchedule,
  setFinalOnlineClassesSchedule,
  isSeparateSchedule,
  finalDrivingClassesSchedule,
  finalInClassClassesSchedule,
  finalOnlineClassesSchedule
}) => {
  // Index into the instructors[] array for each card type
  const [inVehicleIndex, setInVehicleIndex] = useState(0);
  const [inClassIndex, setInClassIndex] = useState(0);
  const [onlineIndex, setOnlineIndex] = useState(0);

  // Track which card type is currently “enabled” (null = none)
  const [selectedInstructorCardType, setSelectedInstructorCardType] = useState(null);

  // Pull hours from CoursePackage
  const { 
    DrivingHours  = 0, 
    InClassHours  = 0, 
    OnlineHours   = 0 
  } = CoursePackage || {};

  useEffect(() => {
    if (instructorSelectedType === "Driving") {
      SelectInstructorCallback("Driving", instructors[inVehicleIndex]);
    }
  }, [inVehicleIndex]);  

  useEffect(() => {
    if (instructorSelectedType === "InClass") {
      SelectInstructorCallback("InClass", instructors[inClassIndex]);
    }
  }, [inClassIndex]);
  
  useEffect(() => {
    if (instructorSelectedType === "Online") {
      SelectInstructorCallback("Online", instructors[onlineIndex]);
    }
  }, [onlineIndex]);
  
  // Whenever we move Next/Prev, we’ll compute the new index,
  // update state immediately, and call SelectInstructorCallback(...) with the new instructor.
  const handleNext = (type) => {
    if (type !== activeType) return;

    if (type === 'Driving') {
      const newIdx = (inVehicleIndex + 1) % instructors.length;
      console.log("newIdx:",newIdx)
      setInVehicleIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Driving")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else if (type === 'InClass') {
      const newIdx = (inClassIndex + 1) % instructors.length;
      setInClassIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("InClass")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else {
      const newIdx = (onlineIndex + 1) % instructors.length;
      setOnlineIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Online")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    }
  };

  const handlePrev = (type) => {
    if (type !== activeType) return;

    if (type === 'Driving') {
      const newIdx = (inVehicleIndex - 1 + instructors.length) % instructors.length;
      console.log("newIdx:",newIdx)
      setInVehicleIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Driving")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else if (type === 'InClass') {
      const newIdx = (inClassIndex - 1 + instructors.length) % instructors.length;
      setInClassIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("InClass")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else {
      const newIdx = (onlineIndex - 1 + instructors.length) % instructors.length;
      setOnlineIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Online")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    }
  };

  // When you click the card, mark that card type as active and immediately select its current instructor
  const handleActivate = (type) => {
    if (instructorSelectedType) {
      if (addClassEvents.length > 0) {
        // Show a popup instead of proceeding
        setSelectedInstructorCardType(type)
        setShowScheduleConfirmationPopup(true); // or setShowPopup(true) or however you're displaying it
        return;
      }
    }

    setActiveType(type);

    // Immediately report the “initial” selection for that card
    if (type === 'Driving') {
      SelectInstructorCallback(type, instructors[inVehicleIndex]);
      setInstructorSelectedType("Driving")
    } else if (type === 'InClass') {
      SelectInstructorCallback(type, instructors[inClassIndex]);
      setInstructorSelectedType("InClass")
    } else {
      SelectInstructorCallback(type, instructors[onlineIndex]);
      setInstructorSelectedType("Online")
    }
  };

  // A helper that returns style props (background & border) for each card type
  const getCardStyles = (type) => {
    switch (type) {
      case 'Driving':
        return {
          buttonColor: '#0AA630',
          cardBg: '#FAFAFB',
          cardBorder: '#0AA630',
          cardBgActive: '#EBF8EE',
        };
      case 'InClass':
        return {
          buttonColor: '#1F7BF4',
          cardBg: '#FAFAFB',
          cardBorder: '#1F7BF4',
          cardBgActive: '#FAFAFB',
        };
      case 'Online':
        return {
          buttonColor: '#FC0000',
          cardBg: '#FAFAFB',
          cardBorder: '#FC0000',
          cardBgActive: '#FFEBEB',
        };
      default:
        return {
          buttonColor: '#CCCCCC',
          cardBg: '#FAFAFB',
          cardBorder: '#CCCCCC',
          cardBgActive: '#FFFFFF',
        };
    }
  };

  // const SchduleConfirmationClick = (type) => {
    
  //   setActiveType(type);

  //   // Immediately report the “initial” selection for that card
  //   if (type === 'Driving') {
  //     SelectInstructorCallback(type, instructors[inVehicleIndex]);
  //     setInstructorSelectedType("Driving")
  //   } else if (type === 'InClass') {
  //     SelectInstructorCallback(type, instructors[inClassIndex]);
  //     setInstructorSelectedType("InClass")
  //   } else {
  //     SelectInstructorCallback(type, instructors[onlineIndex]);
  //     setInstructorSelectedType("Online")
  //   }
  // };

  const SchduleConfirmationClick = (type, finalList = finalClassesSchedule) => {
    setActiveType(type);

    const filteredFinal = finalList.filter(event => event.ClassType !== type);
    const typeClasses = finalList.filter(event => event.ClassType === type);

    setFinalClassesSchedule(filteredFinal);
    setAddClassEvents(typeClasses);
  
    // Step 1: Filter out classes of the selected type from final schedule
    // const filteredFinal = finalClassesSchedule.filter(
    //   event => event.ClassType !== type
    // );
      console.log("filteredFinal in SchduleConfirmationClick:",filteredFinal)
    // Step 2: Extract classes of the selected type to re-edit
    // const typeClasses = finalClassesSchedule.filter(
    //   event => event.ClassType === type
    // );
    console.log("typeClasses in SchduleConfirmationClick:",typeClasses)

    // Step 3: Update state
    setFinalClassesSchedule(filteredFinal);       // Remove old ones
    console.log("finalClassesSchedule in SchduleConfirmationClick:",finalClassesSchedule)

    setAddClassEvents(typeClasses);               // Set them as editable/new
    console.log("addClassEvents in SchduleConfirmationClick:",addClassEvents)

    // Step 4: Handle instructor selection as before
    if (type === 'Driving') {
      SelectInstructorCallback(type, instructors[inVehicleIndex]);
      setInstructorSelectedType("Driving");
    } else if (type === 'InClass') {
      SelectInstructorCallback(type, instructors[inClassIndex]);
      setInstructorSelectedType("InClass");
    } else {
      SelectInstructorCallback(type, instructors[onlineIndex]);
      setInstructorSelectedType("Online");
    }
  };
  
  
  
  // Render one “card” (for Driving, InClass, or Online)
  const renderInstructorCard = (type, label, hours, currentIndex) => {
    const isActive = activeType === type;
    const { buttonColor, cardBg, cardBorder, cardBgActive } = getCardStyles(type);
    const instructor = instructors[currentIndex] || {};

    const getTotalScheduledHours = (scheduleArray) => {
      return scheduleArray.reduce((total, cls) => {
        const start = new Date(cls.StartTime);
        const end = new Date(cls.EndTime);
        const duration = (end - start) / (1000 * 60 * 60); // in hours
        return total + duration;
      }, 0);
    };
    
    let completed = 0;
    if (isSeparateSchedule) {
      if (type === 'Driving') {
        completed = getTotalScheduledHours(finalDrivingClassesSchedule);
      } else if (type === 'InClass') {
        completed = getTotalScheduledHours(finalInClassClassesSchedule);
      } else if (type === 'Online') {
        completed = getTotalScheduledHours(finalOnlineClassesSchedule);
      }
    }
    
  // Conditionally render either "5/10" or just "10"
  const displayHours = isSeparateSchedule ? `${completed}/${hours}` : hours;

    return (
      <div
        key={type}
        className={`flex justify-between w-[450px] 4xl:w-[30%] h-[105px] pl-[15px] cursor-pointer ${
          isActive ? '' : 'opacity-60'
        }`}
        style={{
          backgroundColor: isActive ? "#FAFAFB" : cardBg,
        }}
        onClick={() => handleActivate(type)}
      >
        {/* ── Instructor Info + Prev/Next (only clickable if active) ── */}
        <div className="flex gap-[10px] items-center">
          {/* <img
            src={`${BaseUrl}/api/images/Instructors?url=${instructor.Instructor?.ProfileImage}`}
            alt="Instructor"
            className="w-[66px] h-[66px] rounded-[9px]"
          /> */}
          <div className="relative w-[66px] h-[66px]">
              {/* Instructor Profile Image */}
              <img
                src={`${BaseUrl}/api/images/Instructors?url=${instructor.Instructor?.ProfileImage}`}
                alt="Instructor"
                className="w-[66px] h-[66px] rounded-[9px] object-cover"
              />

              {/* Gender Icon Overlay */}
              {instructor.Instructor?.Gender === "Female" ? (
                <img
                  src={require("../Assets/femaleIcon.svg").default}
                  alt="Female"
                  className="absolute top-[-10px] right-[-10px] w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src={require("../Assets/maleIcon.svg").default}
                  alt="Male"
                  className="absolute top-[-5px] right-[-10px] w-[20px] h-[20px]"
                />
              )}
          </div>
          <div className='flex flex-col gap-[5px]'>
            <p className="text-[16px] font-semibold text-[#696974]">
              {instructor.FirstName} {instructor.LastName}
            </p>
            <p className="text-[16px] font-semilight text-[#696974] w-[110px] break-words whitespace-normal">
              {instructor?.Instructor?.InstructorLanguages} 
            </p>
          </div>

          {/* Prev Arrow */}
          <div
            onClick={() => handlePrev(type)}
            className={`w-[30px] h-[30px] rounded-full flex justify-center items-center ${
              isActive ? 'cursor-pointer' : 'cursor-not-allowed'
            }`}
            style={{ backgroundColor: buttonColor }}
          >
            <ArrowBackIcon sx={{ color: 'white' }} />
          </div>

          {/* Next Arrow */}
          <div
            onClick={() => handleNext(type)}
            className={`w-[30px] h-[30px] rounded-full flex justify-center items-center ${
              isActive ? 'cursor-pointer' : 'cursor-not-allowed'
            }`}
            style={{ backgroundColor: buttonColor }}
          >
            <ArrowForwardIcon sx={{ color: 'white' }} />
          </div>
        </div>

        {/* ── Label + Hours ── */}
        <div
          className="flex flex-col justify-center items-center p-[10px] gap-[10px] bg-no-repeat"
          style={{
            backgroundColor: cardBgActive,
            border: `1px solid ${cardBorder}`,
          }}
        >
          <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">
            {label}
          </p>
          <p className="text-[16px] text-[#696974] font-semibold">{displayHours}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-wrap justify-center 4xl:justify-between items-center gap-[30px] w-full">
      {renderInstructorCard(
        'Driving',
        'In-Vehicle Classes',
        DrivingHours,
        inVehicleIndex
      )}
      {renderInstructorCard(
        'InClass',
        'In-Class Classes',
        InClassHours,
        inClassIndex
      )}
      {renderInstructorCard(
        'Online',
        'Online Classes',
        OnlineHours,
        onlineIndex
      )}

      {showScheduleConfirmationPopup && (
        <ScheduleConfirmationPopup
        setShowScheduleConfirmationPopup={setShowScheduleConfirmationPopup}
        selectedInstructorCardType={selectedInstructorCardType}
        SchduleConfirmationClick={SchduleConfirmationClick}
        setFinalClassesSchedule={setFinalClassesSchedule}
        setAddClassEvents={setAddClassEvents}
        addClassEvents={addClassEvents}
        instructorSelectedType={instructorSelectedType}
        finalClassesSchedule={finalClassesSchedule}
        activeType={activeType}
        setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
        setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
        setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
        />
      )}
    </div>
  );
};

export default InstructorCards;
